export const singIn = {
    "formType": 'singIn',
    "title": 'Реєстрація',
    "dataType": 'singIn',
    "fields": [
        {
            "id": 1,
            "type": 'email',
            "name": 'email',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Email',
                    "type": 'email',
                    "placeholder": 'example@gmail.com'
                }
            ]
        },
        {
            "id": 2,
            "type": 'password',
            "name": 'password',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": 'Пароль',
                    "type": 'password',
                    "placeholder": 'Введіть свій пароль'
                }
            ]
        },
        {
            "id": 3,
            "type": 'select',
            "name": 'role',
            "required": true,
            "options": true,
            "label": 'Роль',
            "props": [
                {
                    "name": 'Адміністратор',
                    "value": 'admin',
                    "roleLabel": 'admin',
                    "type": 'option',
                    "id": 1
                }, {
                    "name": 'Медичний директор',
                    "value": 'admin',
                    "type": 'option',
                    "roleLabel": 'medicalDirector',
                    "id": 2
                },
                // {
                //     "name": 'Лікар',
                //     "value": 'doctor',
                //     "roleLabel": 'doctor',
                //     "type": 'option',
                //     "id": 3
                // },
                {
                    "name": 'Реєстратор медичний',
                    "value": 'registrar',
                    "roleLabel": 'registrar',
                    "type": 'option',
                    "id": 3
                }, {
                    "name": 'Лаборант',
                    "value": 'laboratoryAssistant',
                    "roleLabel": 'laboratoryAssistant',
                    "type": 'option',
                    "id": 4
                }, {
                    "name": 'Помічник лаборанта',
                    "value": 'laboratoryAssistant',
                    "roleLabel": 'assistant',
                    "type": 'option',
                    "id": 5
                }, {
                    "name": 'Лікар-патологоанатом',
                    "value": 'doctor',
                    "roleLabel": 'doctorPathologist',
                    "type": 'option',
                    "id": 6
                }, {
                    "name": 'Лікар-патологоанатом дитячий',
                    "value": 'doctor',
                    "roleLabel": 'doctorPathologistChild',
                    "type": 'option',
                    "id": 7
                }
            ]
        },
        {
            "id": 4,
            "type": 'text',
            "name": 'position',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": 'Посада',
                    "type": 'text',
                    "placeholder": 'Посада'
                }
            ]
        },
        {
            "id": 5,
            "type": 'text',
            "name": 'name',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": "Ім'я",
                    "type": 'text',
                    "placeholder": 'Ім\'я'
                }
            ]
        },
        {
            "id": 6,
            "type": 'text',
            "name": 'surname',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": "Прізвище",
                    "type": 'text',
                    "placeholder": 'Прізвище'
                }
            ]
        },
        {
            "id": 7,
            "type": 'text',
            "name": 'patronymic',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": "По батькові",
                    "type": 'text',
                    "placeholder": 'По батькові'
                }
            ]
        },
        {
            "id": 8,
            "type": 'text',
            "name": 'department',
            "required": false,
            "options": false,
            "props": [
                {
                    "label": "Відділення",
                    "type": 'text',
                    "placeholder": 'Відділення'
                }
            ]
        },
    ],
    "button": 'Зареєструвати',
    "class": 'form__box__login'
}
